import React from "react";
import { useTranslateKey } from "../../hooks/useTranslate";

import {
  useTheme,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";

const MemberSearch = ({
  setSearchField,
  loading,
  currentInput,
  setCurrentInput,
  setPage
}) => {
  const theme = useTheme();
  const viewportIsMedium = useMediaQuery(theme.breakpoints.up("md"));

  const handleKeyDown = (evt) => {
    if (evt.key === "Enter") {
      setSearchField(evt.target.value);
    }
  };

  const handleClearClick = () => {
    setCurrentInput("");
    setSearchField("");
    setPage(0);
  };

  const placeholderText = useTranslateKey("search_by_id_name_phone_etc");

  return (
    <TextField
      id="MemberSearchField"
      value={currentInput}
      onChange={(e) => setCurrentInput(e.target.value)}
      // onBlur={(e) => setSearchField(e.target.value)}
      placeholder={placeholderText}
      onKeyDown={handleKeyDown}
      fullWidth
      disabled={loading}
      inputProps={{
        // the decimal values along with the height determined by the fontSize (17.25px) brings the overall height of the search field to 44px
        style: {
          paddingTop: viewportIsMedium ? "14px" : "13.375px",
          paddingBottom: viewportIsMedium ? "14px" : "13.375px",
          fontSize: viewportIsMedium ? "14px" : "12px",
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment
            position="start"
            sx={{ cursor: "pointer" }}
            onClick={(evt) => setSearchField(currentInput)}
          >
            <img src="icons/search-glass.svg" alt="magnified glass icon" />
          </InputAdornment>
        ),
        endAdornment: currentInput && (
          <IconButton
            size="small"
            onClick={handleClearClick}
            disabled={loading}
          >
            <CloseIcon sx={{ height: "20px" }} />
          </IconButton>
        ),
      }}
    />
  );
};

export { MemberSearch };
